
/**
 * @see "Section 7.2.2, OFX Spec"
 */
export enum CharacterType {

  ALPHAONLY,

  NUMERICONLY,

  ALPHAORNUMERIC,

  ALPHAANDNUMERIC
}
